/*
 * Copyright (c) 2021. Sports IT Solution, Inc.
 */

require('../css/index.scss');
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/brands';
import 'whatwg-fetch';
import Choices from 'choices.js';

function hover() {
  const ua = navigator.userAgent.toLowerCase();
  const is_mobile = ua.indexOf('iphone')
      > -1
      || ua.indexOf('ipad')
      > -1
      || ua.indexOf('android')
      > -1;

  function hoverEvent() {
    this.classList.toggle('is-hover');
  }

  const touch_anchor = document.querySelectorAll('.is-touch a,.is-touch .icon');

  if (touch_anchor != null) {
    if (is_mobile) {
      for (let i = 0; i < touch_anchor.length; i++) {
        touch_anchor[i].addEventListener('touchstart', hoverEvent, false);
      }
    } else {
      for (let _i = 0; _i < touch_anchor.length; _i++) {
        touch_anchor[_i].addEventListener('mouseover', hoverEvent, false);
      }
    }
  }
}

function drawer() {
  const drawer = document.getElementById('js-drawer-nav');
  const drawer_button = document.getElementById('js-btn-drawer');

  function activeEvent() {
    drawer.classList.toggle('is-active');
  }

  if (drawer != null) {
    drawer_button.addEventListener('click', activeEvent, false);
  }
}

const Accordion_nextEl = function () {
  function Accordion_nextEl(el) {
    this.el = el;
  }

  Accordion_nextEl.prototype.showHide = function () {
    for (let i = 0; i < this.el.length; i++) {
      this.el[i].addEventListener('click', function () {
        this.classList.toggle("is-active");
        this.nextElementSibling.classList.toggle("is-active");
      });
    }
  };

  return Accordion_nextEl;
}();

function slimHeader() {
  const header = document.getElementById('js-header-nav');
  const drawer = document.getElementById('js-drawer-nav');

  if (header != null) {
    window.onscroll = function () {
      const scroll_top = window.pageYOffset || document.documentElement.scrollTop;

      if (scroll_top > 90) {
        header.classList.add('is-slim');
        drawer.classList.add('is-slim');
      } else {
        header.classList.remove('is-slim');
        drawer.classList.remove('is-slim');
      }
    };
  }
}

function smoothLink() {
  const headH = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const interval = 10;
  const divisor = 8;
  const range = divisor / 2 + 1;
  const links = document.querySelectorAll('a[href^="#"]');

  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function (e) {
      e.preventDefault();
      let toY;
      let nowY = window.pageYOffset;
      const href = e.target.getAttribute('href');
      const target = document.querySelector(href);
      const targetRect = target.getBoundingClientRect();
      const targetY = targetRect.top + nowY - headH;

      (function doScroll() {
        toY = nowY + Math.round((targetY - nowY) / divisor);
        window.scrollTo(0, toY);
        nowY = toY;

        if (document.body.clientHeight - window.innerHeight < toY) {
          window.scrollTo(0, document.body.clientHeight);
          return;
        }

        if (toY >= targetY + range || toY <= targetY - range) {
          window.setTimeout(doScroll, interval);
        } else {
          window.scrollTo(0, targetY);
        }
      })();
    });
  }
}

function fixTextArea() {
  // HACK : fix textarea height for IE11
  const textAreaElements = document.getElementsByTagName("textarea");
  for (let i = 0; i < textAreaElements.length; i++) {
    const textAreaElement = textAreaElements.item(i);
    const rows = textAreaElement.getAttribute("rows");
    if (rows) {
      textAreaElement.style.cssText = "height: " + rows + "em;";
    }
  }
}

window.addEventListener('load', function () {
  hover();
  drawer();

  const Accordion_content = document.getElementsByClassName("is-accordion");
  new Accordion_nextEl(Accordion_content).showHide();

  slimHeader();
  smoothLink();

  fixTextArea();
});

const setUpFileInput = function (fileInputId, fileNameId) {
  const fileInput = document.getElementById(fileInputId);
  const fileName = document.getElementById(fileNameId);

  fileInput.addEventListener('change', function (event) {
    fileName.textContent = this.files[0].name;
  })
}
window.setUpFileInput = setUpFileInput;

const setUpModal = function (modal, modalBackGrounds, openButton, closeButtons) {
  openButton.addEventListener('click', function (event) {
    modal.classList.add('is-active');
  });
  modalBackGrounds.forEach(function (e) {
    e.addEventListener('click', function (event) {
      modal.classList.remove('is-active');
    });
  });
  closeButtons.forEach(function (e) {
    e.addEventListener('click', function (event) {
      modal.classList.remove('is-active');
    });
  })
};
window.setUpModal = setUpModal;

const setUpLoadingButton = function (buttonElem, formElem) {

  buttonElem.addEventListener('click', function (event) {
    this.disabled = true;
    this.classList.add('is-loading');
    formElem.submit();
  });
}
window.setUpLoadingButton = setUpLoadingButton;

const setUpZipCodeUI = function (zipCode1Id, zipCode2Id, prefectureId, cityId, cityDataListId, addressId) {

  const zipCode1Elem = document.getElementById(zipCode1Id);
  const zipCode2Elem = document.getElementById(zipCode2Id);

  zipCode1Elem.addEventListener('keyup', function (event) {
    inputAddress(zipCode1Elem.value, zipCode2Elem.value);
  });

  zipCode2Elem.addEventListener('keyup', function (event) {
    inputAddress(zipCode1Elem.value, zipCode2Elem.value);
  });

  const inputAddress = function (zipCode1, zipCode2) {

    if (zipCode1.length !== 3 || zipCode2.length !== 4) {
      return;
    }

    fetch(`https://arrow-payment.github.io/postal-code-api/api/v1/${zipCode1}/${zipCode2}.json`)
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {

          const cities = [];

          for (let i = 0; i < json.data.length; i++) {
            const r = json.data[i].ja;

            const prefectureElem = document.getElementById(prefectureId);
            prefectureElem.value = r.prefecture;

            cities.push(r);
          }

          if (cities.length === 1) {
            const cityElem = document.getElementById(cityId);
            const data = cities[0];
            cityElem.value = data.address1 + data.address2;

            if (data.address3 !== '' && data.address4 !== '') {
              const addressElem = document.getElementById(addressId);
              addressElem.value = data.address3 + " " + data.address4;
            }
          } else if (cities.length > 1) {
            const dataList = document.getElementById(cityDataListId);
            if (dataList) {
              dataList.innerHTML = '';
              for (let i = 0; i < cities.length; i++) {
                const data = cities[i];
                const option = document.createElement('option');
                option.value = data.address1 + data.address2;

                dataList.appendChild(option);
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
  }
}
window.setUpZipCodeUI = setUpZipCodeUI;

const setUpCitySelect = function (prefectureSelect, citySelect, initialCityId, uri) {

  prefectureSelect.addEventListener('change', function (event) {
    const prefecture = this.value;

    if (!prefecture) {
      clearCities();
      return;
    }

    fetch(`${uri}?prefecture=${encodeURIComponent(prefecture)}&hasClubs=true`)
        .then(function (response) {
          return response.json();
        })
        .then(function (cities) {
          clearCities();
          for (let i = 0; i < cities.length; i++) {
            citySelect.add(createOption(cities[i]));
          }
          citySelect.value = initialCityId;
        })
        .catch(function (error) {
          console.error(error);
        });
  });
  prefectureSelect.dispatchEvent(new Event('change'));

  function createOption(city) {
    const option = document.createElement("option");
    option.value = city.id;
    option.text = city.name + ' (' + city.code + ')';

    return option;
  }

  function clearCities() {
    citySelect.options.length = 0;
    const option = document.createElement("option");
    option.value = "";
    option.text = "未指定";
    citySelect.add(option);
  }
}
window.setUpCitySelect = setUpCitySelect;

const rome = require('@bevacqua/rome');

rome.moment.locale('ja', {
  months: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  monthsShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
  weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"],
  weekdaysMin: ["日", "月", "火", "水", "木", "金", "土"]
});

window.rome = rome;

window.bindSingleChoices = function (selectElem, queryFunction, placeholder) {

  const uri = selectElem.dataset.uri;

  const load = function (_choices, _params) {

    fetch(uri + "?" + new URLSearchParams(_params).toString())
        .then(function (response) {
          return response.json();
        })
        .then(function (res) {
          _choices.clearChoices();
          _choices.setValue(res.map(function (item) {
            return {
              id: item.id, value: item.id, label: item.name
            }
          }));
        });
  }

  const choices = new Choices(selectElem, {
    searchChoices: false,
    maxItemCount: 10,
    allowHTML: false,
    searchPlaceholderValue: placeholder || 'キーワードを入力して選択候補を検索します',
    noChoicesText: 'キーワードを含む候補が検索されませんでした',
    itemSelectText: '選択',
  });

  const initialId = selectElem.dataset.initialId;

  if (initialId) {
    load(choices, {id: initialId});
  }

  selectElem.addEventListener('search', function (event) {

    if (event.detail.value) {
      load(choices, queryFunction(event.detail.value));
    } else {
      choices.setValue([]);
    }
  });

  return choices;
}